import TTaskForInput from '../types/TTaskForInput';

export default (tasks: TTaskForInput[], id: number) => tasks.find(task => task.id === id);
